<template>
  <div>

  	<div v-if="!kit">
  		<!-- user content -->
		<div v-if="content.service_welcome_greeting_guest" class="mb-2" v-html="content.service_welcome_greeting_guest"></div>
		<a href="javascript:void(0)" @click="openLoginWindow()" class="btn btn-primary mt-1 mb-2 mr-1">Starten Sie hier</a>
  	</div>

  	<div v-else>

  		<div class="step-1" v-if="!formdata.selectedArea">
  			<div class="spinner-border text-primary mr-2" role="status" v-if="loading || areas.length == 0">
                <span class="sr-only">Loading...</span>
            </div>
            <div v-else>
	  			<!--<h5 class="mb-4">Bitte wählen Sie einen Servicebereich aus (Area)</h5>-->
	  			<h5 v-if="content.service_title_area" class="mb-4" v-html="content.service_title_area"></h5>
	  			<div class="d-flex justify-content-center align-items-center gap flex-wrap">
		  			<div v-for="area in areas">
		  				<button class="btn btn-primary btn-square mb-2" @click="onSetArea(''+area.name+'')">{{ area.name }}</button>
		  			</div>
		  		</div>
	  		</div>
  		</div>

  		<div class="step-2" v-if="formdata.selectedArea && !formdata.selectedGroup">
  			<!--<h5 class="mb-4">Bitte wählen Sie eine Servicegruppe aus (Group)</h5>-->
  			<h5 v-if="content.service_title_group" class="mb-4" v-html="content.service_title_group"></h5>
  			<div v-for="area in areas">
  				<div v-if="area.name == formdata.selectedArea">
  					<div class="d-flex justify-content-center align-items-center gap flex-wrap">
	  					<div v-for="group in area.groups">

	  						<button class="btn btn-primary mb-2" @click="onSetGroup(''+group+'')">

	  							<div v-if="group.toLowerCase().includes('wechsel')" class="mb-1">
										<!-- icon change -->
										<svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon-white">
										<g clip-path="url(#clip0_2_619)">
										<path d="M3.5 12.6899V30.6899H21.5" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M69.5 60.6899V42.6899H51.5" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M61.97 27.69C60.4485 23.3904 57.8626 19.5463 54.4536 16.5163C51.0446 13.4863 46.9236 11.3693 42.4751 10.3628C38.0267 9.3563 33.3957 9.49307 29.0144 10.7604C24.6331 12.0277 20.6442 14.3842 17.42 17.61L3.5 30.69M69.5 42.69L55.58 55.77C52.3558 58.9959 48.3669 61.3524 43.9856 62.6197C39.6043 63.887 34.9733 64.0238 30.5249 63.0173C26.0764 62.0108 21.9554 59.8937 18.5464 56.8638C15.1374 53.8338 12.5515 49.9897 11.03 45.69" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
										</g>
										<defs>
										<clipPath id="clip0_2_619">
										<rect width="72" height="72" fill="white" transform="translate(0.5 0.690002)"/>
										</clipPath>
										</defs>
										</svg>
									</div>

									<div v-else-if="group.toLowerCase().includes('inspektion')" class="mb-1">
										<!-- icon inspektion -->
										<svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon-white">
										<path d="M66.5 36.6899H54.5L45.5 63.6899L27.5 9.68994L18.5 36.6899H6.5" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</div>

									<div v-else-if="group.toLowerCase().includes('motor')" class="mb-1">
										<!-- icon engine -->
										<svg class="svg-icon-white" xmlns="http://www.w3.org/2000/svg" width="73" height="73" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
										  <path d="M3 10v6"></path>
										  <path d="M12 5v3"></path>
										  <path d="M10 5h4"></path>
										  <path d="M5 13h-2"></path>
										  <path d="M6 10h2l2 -2h3.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2v-2h-3v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6z"></path>
										</svg>
									</div>

									<div v-else-if="group.toLowerCase().includes('bremsen')" class="mb-1">
										<!-- icon break -->
										<svg class="svg-icon-white" width="73" height="73" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></circle><circle cx="24" cy="24" r="4" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></circle><path d="M24 4C26.6264 4 29.2272 4.51732 31.6537 5.52241C34.0802 6.5275 36.285 8.00069 38.1421 9.85787C39.9993 11.715 41.4725 13.9198 42.4776 16.3463C43.4827 18.7728 44 21.3736 44 24L36.0064 24C36.0064 22.4233 35.6959 20.862 35.0925 19.4053C34.4891 17.9487 33.6047 16.6251 32.4898 15.5102C31.3749 14.3953 30.0513 13.5109 28.5947 12.9075C27.138 12.3041 25.5767 11.9936 24 11.9936V4Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
									</div>

									<div v-else-if="group.toLowerCase().includes('kühler')" class="mb-1">
										<!-- icon fan -->
										<svg class="svg-icon-white" width="73" height="73" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2023 Fonticons, Inc. --><path d="M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"></path></svg>
									</div>

									<div v-else class="mb-1">
										<!-- icon board -->
										<svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon-white">
										<path d="M48.5 12.5H54.5C56.0913 12.5 57.6174 13.1321 58.7426 14.2574C59.8679 15.3826 60.5 16.9087 60.5 18.5V60.5C60.5 62.0913 59.8679 63.6174 58.7426 64.7426C57.6174 65.8679 56.0913 66.5 54.5 66.5H18.5C16.9087 66.5 15.3826 65.8679 14.2574 64.7426C13.1321 63.6174 12.5 62.0913 12.5 60.5V18.5C12.5 16.9087 13.1321 15.3826 14.2574 14.2574C15.3826 13.1321 16.9087 12.5 18.5 12.5H24.5" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M45.5 6.5H27.5C25.8431 6.5 24.5 7.84315 24.5 9.5V15.5C24.5 17.1569 25.8431 18.5 27.5 18.5H45.5C47.1569 18.5 48.5 17.1569 48.5 15.5V9.5C48.5 7.84315 47.1569 6.5 45.5 6.5Z" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</div>

		  						<div>{{ group }}</div>

		  					</button>

	  					</div>

	  				</div>

	  							<div v-if="debug">
		  							<!-- DEBUG -->
										<hr />
			  						<div>Verfügbare Icons</div>

			  						<div class="d-flex justify-items-center align-items-center">
			  						 <div class="mb-1">
											<!-- icon change -->
											<svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
											<g clip-path="url(#clip0_2_619)">
											<path d="M3.5 12.6899V30.6899H21.5" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M69.5 60.6899V42.6899H51.5" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M61.97 27.69C60.4485 23.3904 57.8626 19.5463 54.4536 16.5163C51.0446 13.4863 46.9236 11.3693 42.4751 10.3628C38.0267 9.3563 33.3957 9.49307 29.0144 10.7604C24.6331 12.0277 20.6442 14.3842 17.42 17.61L3.5 30.69M69.5 42.69L55.58 55.77C52.3558 58.9959 48.3669 61.3524 43.9856 62.6197C39.6043 63.887 34.9733 64.0238 30.5249 63.0173C26.0764 62.0108 21.9554 59.8937 18.5464 56.8638C15.1374 53.8338 12.5515 49.9897 11.03 45.69" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
											</g>
											<defs>
											<clipPath id="clip0_2_619">
											<rect width="72" height="72" fill="white" transform="translate(0.5 0.690002)"/>
											</clipPath>
											</defs>
											</svg>
										</div>

										<div class="mb-1">
											<!-- icon inspektion -->
											<svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
											<path d="M66.5 36.6899H54.5L45.5 63.6899L27.5 9.68994L18.5 36.6899H6.5" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
										</div>

										<div class="mb-1">
											<!-- icon board -->
											<svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
											<path d="M48.5 12.5H54.5C56.0913 12.5 57.6174 13.1321 58.7426 14.2574C59.8679 15.3826 60.5 16.9087 60.5 18.5V60.5C60.5 62.0913 59.8679 63.6174 58.7426 64.7426C57.6174 65.8679 56.0913 66.5 54.5 66.5H18.5C16.9087 66.5 15.3826 65.8679 14.2574 64.7426C13.1321 63.6174 12.5 62.0913 12.5 60.5V18.5C12.5 16.9087 13.1321 15.3826 14.2574 14.2574C15.3826 13.1321 16.9087 12.5 18.5 12.5H24.5" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M45.5 6.5H27.5C25.8431 6.5 24.5 7.84315 24.5 9.5V15.5C24.5 17.1569 25.8431 18.5 27.5 18.5H45.5C47.1569 18.5 48.5 17.1569 48.5 15.5V9.5C48.5 7.84315 47.1569 6.5 45.5 6.5Z" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
										</div>
										</div>
									<hr />

									</div>

									<!-- DEBUG -->

  				</div>
  			</div>
  		</div>

  		<div class="step-3" v-if="formdata.selectedGroup && !servicesSet">
  			<!--<h5 class="mb-4">Bitte wählen Sie eine/mehrere Serviceleistung(en) aus</h5>-->
  			<h5 v-if="content.service_title_services" class="mb-4" v-html="content.service_title_services"></h5>
  			<div class="d-flex justify-content-center align-items-center gap flex-wrap">
	  			<div v-for="service in services.value" v-if="service.area == formdata.selectedArea && service.groups.includes(formdata.selectedGroup)" class="col-6 col-sm-4 mb-4">
  					<div class="card btn-card text-center px-2 py-4" @click="onToggleService(service)" :class="formdata.selectedServices.includes(service) ? 'active': ''">
  						<div class="text-primary mb-2">{{ service.description }}</div>
  						<!--<p>
  							Dauer: {{ service.duration }} min<br />
  							Preis: {{ service.price }} Eur<br />
  							(inkl. {{ service.taxRate }} MwSt.)
  						</p>-->
	  					<!--<p>
	  						key: {{ service.key }}<br />
		  					area: {{ service.area }}<br />
		  					groups: {{ service.groups }}<br />
		  					description: {{ service.description }}<br />
		  					duration: {{ service.duration }}<br />
		  					price: {{ service.price }}<br />
		  					taxRate: {{ service.taxRate }}<br />
		  					requiredOptions: {{ service.requiredOptions }}
	  					</p>-->
	  					<div v-if="!formdata.selectedServices.includes(service)">
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M24 44.6899C35.0457 44.6899 44 35.7356 44 24.6899C44 13.6442 35.0457 4.68994 24 4.68994C12.9543 4.68994 4 13.6442 4 24.6899C4 35.7356 12.9543 44.6899 24 44.6899Z" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M24 16.6899V32.6899" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M16 24.6899H32" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
	  					</div>
	  					<div v-else>
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M44 22.8499V24.6899C43.9975 29.0028 42.601 33.1993 40.0187 36.6536C37.4363 40.1079 33.8066 42.6349 29.6707 43.8577C25.5349 45.0806 21.1145 44.9337 17.0689 43.4391C13.0234 41.9445 9.56931 39.1821 7.22192 35.564C4.87453 31.946 3.75958 27.666 4.04335 23.3625C4.32712 19.059 5.99441 14.9626 8.79656 11.6841C11.5987 8.40555 15.3856 6.12068 19.5924 5.17021C23.7992 4.21973 28.2005 4.65459 32.14 6.40992" stroke="#F2F2F2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M44 8.68994L24 28.7099L18 22.7099" stroke="#F2F2F2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
	  					</div>
	  				</div>
	  			</div>
	  		</div>
	  		<div class="d-flex justify-content-center align-items-center gap">
				<!--<button class="btn btn-primary" @click="onSetServices()" v-if="formdata.selectedServices.length > 0">
					<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1">
						<path d="M19.5 12.1899L5.5 12.1899" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M12.5 19.1899L5.5 12.1899L12.5 5.18994" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
	  				<div class="spinner-border text-white mr-2" role="status" v-if="loading">
                        <span class="sr-only">Loading...</span>
                    </div>
                    Zurück
	  			</button>-->
	  			<button class="btn btn-primary" @click="onSetServices()" v-if="formdata.selectedServices.length > 0">
	  				<div class="spinner-border text-white mr-2" role="status" v-if="loading">
                        <span class="sr-only">Loading...</span>
                    </div>
                    Weiter
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
						<path d="M5.5 12.1899H19.5" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M12.5 5.18994L19.5 12.1899L12.5 19.1899" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
	  			</button>
	  		</div>
  		</div>

  		<div class="step-4" v-if="servicesSet && !additionalOptionsSet">

  			<!--<h5 class="mb-4">Sie können hier noch zusätzliche Serviceoptionen auswählen</h5>-->
  			<h5 v-if="content.service_title_options" class="mb-4" v-html="content.service_title_options"></h5>

  			<div class="d-sm-flex justify-content-center">

  				<!--
  				2023-02-01:
  				- Erforderliche Optionen sollen wegen fehlendem Button ausgeblendet werden: v-if="!requiredOptions.includes(option.option)"
				- Nicht verfügbare Optoinen sollen ausgeblendet werden
				2023-03-03:
				- possibleOptionsInitial hinzugefügt
  				-->
	  			<div v-for="option in servicesAdditionalOptions.value" class="col-md-4 mb-4" v-if="!requiredOptions.includes(option.option) && possibleOptionsInitial.includes(option.option)">

  					<div class="card btn-card text-center px-2 py-4" @click="onToggleAdditionalOption(option)" :class="formdata.selectedAdditionalOptions.includes(option) ? 'active': ''">

  						<div class="text-primary mb-2">{{ option.description }}</div>

						<div v-if="requiredOptions.includes(option.option)" class="mb-2">
	  						<span class="badge badge-warning">Erforderlich</span>
	  					</div>
	  					<div v-else class="mb-2">
	  						<span class="badge badge-info">Optional</span>
	  					</div>

  						<!--<p>
	  						option: {{ option.option }}<br />
		  					description: {{ option.description }}<br />
		  					possibleOtherOptions: {{ option.possibleOtherOptions }}<br />
	  					</p>-->

	  					<!-- Add/Delete Buttons -->
	  					<div v-if="possibleOptions.length > 0 && possibleOptions.includes(option.option)">
		  					<div v-if="!formdata.selectedAdditionalOptions.includes(option)">
		  						<!--<button class="btn btn-success" @click="onAddAdditionalOption(option)">Hinzufügen</button>-->
								<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M24 44.6899C35.0457 44.6899 44 35.7356 44 24.6899C44 13.6442 35.0457 4.68994 24 4.68994C12.9543 4.68994 4 13.6442 4 24.6899C4 35.7356 12.9543 44.6899 24 44.6899Z" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M24 16.6899V32.6899" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M16 24.6899H32" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
		  					</div>
		  					<div v-else>
		  						<!--<button class="btn btn-danger" @click="onRemoveAdditionalOption(option)">Entfernen</button>-->
								<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M44 22.8499V24.6899C43.9975 29.0028 42.601 33.1993 40.0187 36.6536C37.4363 40.1079 33.8066 42.6349 29.6707 43.8577C25.5349 45.0806 21.1145 44.9337 17.0689 43.4391C13.0234 41.9445 9.56931 39.1821 7.22192 35.564C4.87453 31.946 3.75958 27.666 4.04335 23.3625C4.32712 19.059 5.99441 14.9626 8.79656 11.6841C11.5987 8.40555 15.3856 6.12068 19.5924 5.17021C23.7992 4.21973 28.2005 4.65459 32.14 6.40992" stroke="#F2F2F2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M44 8.68994L24 28.7099L18 22.7099" stroke="#F2F2F2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
		  					</div>
		  				</div>
		  				<div v-else>
		  					<div v-if="formdata.selectedAdditionalOptions.includes(option)">
		  						<!--<button class="btn btn-danger" @click="onRemoveAdditionalOption(option)">Entfernen</button>-->
								<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M44 22.8499V24.6899C43.9975 29.0028 42.601 33.1993 40.0187 36.6536C37.4363 40.1079 33.8066 42.6349 29.6707 43.8577C25.5349 45.0806 21.1145 44.9337 17.0689 43.4391C13.0234 41.9445 9.56931 39.1821 7.22192 35.564C4.87453 31.946 3.75958 27.666 4.04335 23.3625C4.32712 19.059 5.99441 14.9626 8.79656 11.6841C11.5987 8.40555 15.3856 6.12068 19.5924 5.17021C23.7992 4.21973 28.2005 4.65459 32.14 6.40992" stroke="#F2F2F2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M44 8.68994L24 28.7099L18 22.7099" stroke="#F2F2F2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
		  					</div>
		  					<div v-else>
			  					<div v-if="!requiredOptions.includes(option.option)">
			  						<button class="btn btn-light" disabled>nicht verfügbar</button>
			  					</div>
			  				</div>
		  				</div>

	  				</div>

	  			</div>

	  		</div>

	  		<div class="d-flex justify-content-center align-items-center gap">
	  			<button class="btn btn-primary" @click="onSetAdditionalOptions()">
	  				<div class="spinner-border text-white mr-2" role="status" v-if="loading">
                        <span class="sr-only">Loading...</span>
                    </div>
	  				Weiter
	  				<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
						<path d="M5.5 12.1899H19.5" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M12.5 5.18994L19.5 12.1899L12.5 19.1899" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
	  			</button>
	  		</div>

  		</div>

		<div class="step-5" v-if="additionalOptionsSet && !formdata.optionInKey">

  			<!--<h5 class="mb-4">Wählen Sie einen gewünschrten Übergabe- und Rückgabezeitpunkt aus</h5>-->
  			<h5 class="mb-4" v-html="content.service_title_handover" v-if="!hasReturnDate()"></h5>
  			<h5 v-if="hasReturnDate()" class="d-flex align-items-center justify-content-between">
  				<span v-html="content.service_title_handover_in"></span>
				<span class="mb-3">
					<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
						<path d="M1.5 10L5.5 6H14L17 10L22.5 11.3333V16H1.5V10Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M1.5 10L16.5 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M9.5 16L9.5 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M17.5 16L16.5 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M8 16.6899C8 18.0707 6.88071 19.1899 5.5 19.1899C4.11929 19.1899 3 18.0707 3 16.6899" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M21 16.6899C21 18.0707 19.8807 19.1899 18.5 19.1899C17.1193 19.1899 16 18.0707 16 16.6899" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
						<path d="M5.5 12.1899H19.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M12.5 5.18994L19.5 12.1899L12.5 19.1899" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</span>
  			</h5>

  			<div class="row">

	  			<div v-for="option in servicesInOutOptions.value" class="col-md-6 mb-4">

  					<div class="card btn-card text-center p-3" @click="onSetOptionIn(option.key)">

						<div v-if="option.description.includes('Morgen')" class="mb-1">
							<!-- icon morgens -->
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M34 36.6899C34 34.0378 32.9464 31.4942 31.0711 29.6189C29.1957 27.7435 26.6522 26.6899 24 26.6899C21.3478 26.6899 18.8043 27.7435 16.9289 29.6189C15.0536 31.4942 14 34.0378 14 36.6899" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M24 4.68994V18.6899" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M8.44 21.1299L11.28 23.9699" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M2 36.6899H6" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M42 36.6899H46" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M36.72 23.9699L39.56 21.1299" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M46 44.6899H2" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M16 12.6899L24 4.68994L32 12.6899" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>

						<div v-else-if="option.description.includes('Nachmittag')" class="mb-1">
							<!-- icon nachmittag/abend -->
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M34 36.6899C34 34.0378 32.9464 31.4942 31.0711 29.6189C29.1957 27.7435 26.6522 26.6899 24 26.6899C21.3478 26.6899 18.8043 27.7435 16.9289 29.6189C15.0536 31.4942 14 34.0378 14 36.6899" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M24 18.6899V4.68994" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M8.44 21.1299L11.28 23.9699" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M2 36.6899H6" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M42 36.6899H46" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M36.72 23.9699L39.56 21.1299" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M46 44.6899H2" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M32 10.6899L24 18.6899L16 10.6899" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>

						<div v-else-if="option.description.includes('Abend')" class="mb-1">
							<!-- icon nachmittag/abend -->
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M34 36.6899C34 34.0378 32.9464 31.4942 31.0711 29.6189C29.1957 27.7435 26.6522 26.6899 24 26.6899C21.3478 26.6899 18.8043 27.7435 16.9289 29.6189C15.0536 31.4942 14 34.0378 14 36.6899" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M24 18.6899V4.68994" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M8.44 21.1299L11.28 23.9699" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M2 36.6899H6" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M42 36.6899H46" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M36.72 23.9699L39.56 21.1299" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M46 44.6899H2" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M32 10.6899L24 18.6899L16 10.6899" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>

						<div v-else>
							<!-- icon kalender -->
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M38 8.68994H10C7.79086 8.68994 6 10.4808 6 12.6899V40.6899C6 42.8991 7.79086 44.6899 10 44.6899H38C40.2091 44.6899 42 42.8991 42 40.6899V12.6899C42 10.4808 40.2091 8.68994 38 8.68994Z" stroke="#4F4F4F" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M32 4.68994V12.6899" stroke="#4F4F4F" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M16 4.68994V12.6899" stroke="#4F4F4F" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M6 20.6899H42" stroke="#4F4F4F" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>

  						<div class="text-black my-2"><strong>{{ option.description }}</strong></div>

  						<p>
  							{{ formatTime(option.start) }} Uhr -
		  					{{ formatTime(option.end) }} Uhr
  						</p>

	  					<!--<p>
		  					description: {{ option.description }}<br />
		  					start: {{ formatTime(option.start) }} Uhr<br />
		  					end: {{ formatTime(option.end) }} Uhr<br />
		  					start: {{ option.start }}<br />
		  					end: {{ option.end }}<br />
		  					key: {{ option.key }}<br />
	  					</p>-->

	  					<button class="btn btn-success">
	  						<div class="spinner-border text-primary mr-2" role="status" v-if="loading">
                				<span class="sr-only">Loading...</span>
            				</div>
	  						Auswählen
	  					</button>

	  				</div>

	  			</div>

	  		</div>

  		</div>

		<div class="step-6" v-if="formdata.optionInKey && !formdata.optionOutKey && hasReturnDate()">

  			<h5 v-if="content.service_title_handover_out" class="d-flex align-items-center justify-content-between">
  				<span v-html="content.service_title_handover_out"></span>
				<span class="mb-3">
					<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
						<path d="M19.5 12.1899L5.5 12.1899" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M12.5 19.1899L5.5 12.1899L12.5 5.18994" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
						<path d="M1.5 10L5.5 6H14L17 10L22.5 11.3333V16H1.5V10Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M1.5 10L16.5 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M9.5 16L9.5 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M17.5 16L16.5 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M8 16.6899C8 18.0707 6.88071 19.1899 5.5 19.1899C4.11929 19.1899 3 18.0707 3 16.6899" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M21 16.6899C21 18.0707 19.8807 19.1899 18.5 19.1899C17.1193 19.1899 16 18.0707 16 16.6899" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</span>
  			</h5>

  			<div class="row">

	  			<div v-for="option in servicesInOutOptions.value" class="col-md-6 mb-4">

  					<div class="card btn-card text-center p-3" @click="onSetOptionOut(option.key)">

						<div v-if="option.description.includes('Morgen')" class="mb-1">
							<!-- icon morgens -->
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M34 36.6899C34 34.0378 32.9464 31.4942 31.0711 29.6189C29.1957 27.7435 26.6522 26.6899 24 26.6899C21.3478 26.6899 18.8043 27.7435 16.9289 29.6189C15.0536 31.4942 14 34.0378 14 36.6899" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M24 4.68994V18.6899" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M8.44 21.1299L11.28 23.9699" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M2 36.6899H6" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M42 36.6899H46" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M36.72 23.9699L39.56 21.1299" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M46 44.6899H2" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M16 12.6899L24 4.68994L32 12.6899" stroke="#F2994A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>

						<div v-else-if="option.description.includes('Nachmittag')" class="mb-1">
							<!-- icon nachmittag/abend -->
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M34 36.6899C34 34.0378 32.9464 31.4942 31.0711 29.6189C29.1957 27.7435 26.6522 26.6899 24 26.6899C21.3478 26.6899 18.8043 27.7435 16.9289 29.6189C15.0536 31.4942 14 34.0378 14 36.6899" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M24 18.6899V4.68994" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M8.44 21.1299L11.28 23.9699" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M2 36.6899H6" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M42 36.6899H46" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M36.72 23.9699L39.56 21.1299" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M46 44.6899H2" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M32 10.6899L24 18.6899L16 10.6899" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>

						<div v-else-if="option.description.includes('Abend')" class="mb-1">
							<!-- icon nachmittag/abend -->
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M34 36.6899C34 34.0378 32.9464 31.4942 31.0711 29.6189C29.1957 27.7435 26.6522 26.6899 24 26.6899C21.3478 26.6899 18.8043 27.7435 16.9289 29.6189C15.0536 31.4942 14 34.0378 14 36.6899" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M24 18.6899V4.68994" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M8.44 21.1299L11.28 23.9699" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M2 36.6899H6" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M42 36.6899H46" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M36.72 23.9699L39.56 21.1299" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M46 44.6899H2" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M32 10.6899L24 18.6899L16 10.6899" stroke="#BB6BD9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>

						<div v-else>
							<!-- icon kalender -->
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M38 8.68994H10C7.79086 8.68994 6 10.4808 6 12.6899V40.6899C6 42.8991 7.79086 44.6899 10 44.6899H38C40.2091 44.6899 42 42.8991 42 40.6899V12.6899C42 10.4808 40.2091 8.68994 38 8.68994Z" stroke="#4F4F4F" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M32 4.68994V12.6899" stroke="#4F4F4F" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M16 4.68994V12.6899" stroke="#4F4F4F" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M6 20.6899H42" stroke="#4F4F4F" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>

  						<div class="text-black my-2"><strong>{{ option.description }}</strong></div>

  						<p>
  							{{ formatTime(option.start) }} Uhr -
		  					{{ formatTime(option.end) }} Uhr
  						</p>

	  					<!--<p>
		  					description: {{ option.description }}<br />
		  					start: {{ formatTime(option.start) }} Uhr<br />
		  					end: {{ formatTime(option.end) }} Uhr<br />
		  					start: {{ option.start }}<br />
		  					end: {{ option.end }}<br />
		  					key: {{ option.key }}<br />
	  					</p>-->

	  					<button class="btn btn-success">
	  						<div class="spinner-border mr-2" role="status" v-if="loading">
                				<span class="sr-only">Loading...</span>
            				</div>
	  						Auswählen
	  					</button>

	  				</div>

	  			</div>

	  		</div>

  		</div>

  		<div class="step-7" v-if="formdata.optionOutKey && !jobInfo">

  			<div class="spinner-border text-primary mr-2" role="status" v-if="loading">
                <span class="sr-only">Loading...</span>
            </div>
            <div v-else class="mb-4">

            	<h5><p v-if="content.service_title_calendar_in_only && !hasReturnDate()" class="mb-4" v-html="content.service_title_calendar_in_only"></p></h5>
            	<h5><p v-if="content.service_title_calendar_in_out && hasReturnDate()" class="mb-4" v-html="content.service_title_calendar_in_only"></p></h5>

				<!--<h5>Bitte wählen Sie einen Eingangstermin</h5>-->
		  		<h5><p v-if="content.service_title_inbound" class="mb-2" v-html="content.service_title_inbound"></p></h5>

	  			<div v-if="selectedAppointmentTimeIn" class="calendar-slot-excerpt">
	  				<div class="label-small">Ihr ausgewählter Tag/Uhrzeit für die <strong>Abgabe</strong>:</div>
	  				<div class="d-flex justify-content-between align-items-center">
	  					<div class="p-1"><span v-html="formatDateWithDay(selectedDateTimeIn)" class="mr-2"></span><span class="highlighted">{{ selectedAppointmentTimeIn }}</span>Uhr</div>
						<div class="action-links">
							<a class="cursor-pointer mr-1" @click="adjustAppointmentTimeIn = !adjustAppointmentTimeIn">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="margin-top: -1px;"><g clip-path="url(#clip0_2_578)"><path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g> <defs><clipPath id="clip0_2_578"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>
							</a>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
								<path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M22 4L12 14.01L9 11.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>
					</div>
	  			</div>

	  			<div v-show="!selectedAppointmentTimeIn || adjustAppointmentTimeIn">

	  				<!-- change date range -->
		  			<div class="d-flex justify-content-center align-items-center my-4">
		  				<a href="javascript:void(0);" @click="onRemoveWeek()" v-if="hasNotPast()"><i class="fa fa fa-chevron-circle-left" aria-hidden="true"></i></a>
		  				<div class="px-2">{{ formatDateYear(formdata.currentDay) }} - {{ formatDateYear(calendarEndDay) }}</div>
		  				<a  href="javascript:void(0);" @click="onAddWeek()"><i class="fa fa fa-chevron-circle-right" aria-hidden="true"></i></a>
		  			</div>

		  			<vc-date-picker v-model="datepickerIn.selectedDate" :value="null" :min-date='datepickerIn.attributes.min_date' :max-date='datepickerIn.attributes.max_date' is-inline is-expanded title-position="left" :available-dates='datepickerIn.attributes.available_dates' :disabled-dates='datepickerIn.attributes.disabled_dates' @dayclick='onDayClickedIn' ref="refDatepickerIn" />

		  			<div v-if="datepickerIn.selectedDate" class="row mt-2 booking-slots">
		  				<div v-for="slot in serviceSlotsDayIn" class="col-6 col-sm-3">
		  					<div class="booking-slot p-2 mb-2 shadow rounded text-center" :class="{ active: selectedAppointmentTimeIn == slot }" @click="onSetAppointmentSlotIn(slot)">
		  						<small>{{ slot }} Uhr</small>
		  					</div>
		  				</div>
		  			</div>

		  		</div>


	  			<div v-if="!singleSlotOut" class="mb-4">

		  			<div v-if="selectedAppointmentTimeIn">

		  				<!--<h5>Bitte wählen Sie einen Abholtermin</h5>-->
		  				<h5><p v-if="content.service_title_outbound" class="mb-2" v-html="content.service_title_outbound"></p></h5>

		  				<div v-if="selectedAppointmentTimeOut" class="calendar-slot-excerpt">

			  				<div class="label-small">Ihr ausgewählter Tag/Uhrzeit für die <strong>Abholung</strong>:</div>
			  				<div class="d-flex justify-content-between align-items-center">
			  					<div class="p-1"><span v-html="formatDateWithDay(selectedDateTimeOut)" class="mr-2"></span><span class="highlighted">{{ selectedAppointmentTimeOut }}</span>Uhr</div>
								<div class="action-links">
									<a class="cursor-pointer mr-1" @click="adjustAppointmentTimeOut = !adjustAppointmentTimeOut">
										<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="margin-top: -1px;"><g clip-path="url(#clip0_2_578)"><path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g> <defs><clipPath id="clip0_2_578"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>
									</a>
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
										<path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M22 4L12 14.01L9 11.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
							</div>
			  			</div>

			  			<div v-show="!selectedAppointmentTimeOut || adjustAppointmentTimeOut">

			  				<vc-date-picker v-model="datepickerOut.selectedDate" :value="null" :min-date='datepickerOut.attributes.min_date' :max-date='datepickerIn.attributes.max_date' is-inline is-expanded title-position="left" :available-dates='datepickerOut.attributes.available_dates' :disabled-dates='datepickerOut.attributes.disabled_dates' @dayclick='onDayClickedOut' ref="refDatepickerOut" />

				  			<div v-if="datepickerOut.selectedDate" class="row mt-2 booking-slots">
				  				<div v-for="slot in serviceSlotsDayOut" class="col-6 col-sm-3">
				  					<div class="booking-slot p-2 mb-2 shadow rounded text-center" :class="{ active: selectedAppointmentTimeOut == slot }" @click="onSetAppointmentSlotOut(slot)">
				  						<small>{{ slot }} Uhr</small>
				  					</div>
				  				</div>
				  			</div>

				  		</div>

		  			</div>

		  		</div>
		  		<!--<div v-else>
		  			<div class="my-2">
		  				<span class="badge badge-success">
		  					<i class="fa fa-info-circle" aria-hidden="true"></i> Ihr Rückgabetermin ist am {{ formatDate(datepickerOut.attributes.available_dates[0]) }} um {{ selectedAppointmentTimeOut }} Uhr.
		  				</span>
		  			</div>
		  		</div>-->

	  			<div v-if="formdata.selectedAppointmentSlot">

	  				<KSRSelectVehicle @setvehicle="setVehicle" :kit="kit" />
	  				<div class="invalid-feedback d-block invalid-vehicle" v-if="formdata_errors.includes('licenseplate')">
             	Bitte wählen Sie ein Fahrzeug aus.
            </div>

	  				<!--<div class="form-row mt-4">

                        <div class="form-group col-md-5">
                            <label class="form-label">Ihr Kennzeichen<span class="text-danger">*</span>:</label>
                            <input type="text" name="licenseplate" v-model="formdata.licenseplate" class="form-control" @keyup="formatLicensePlate($event.target.value)">
                            <p class="small text-muted m-0">z.B. NU-KS 123</p>
                            <div class="invalid-feedback d-block" v-if="formdata_errors.includes('licenseplate')">
                                Bitte geben Sie Ihr Kennzeichen an.
                            </div>
                        </div>

                        <div class="form-group col-md-5">
                            <label class="form-label">Erstzulassung:</label>
                            <input type="date" name="ez" v-model="formdata.ez" class="form-control">
                            <p class="small text-muted m-0">z.B. 01.04.2000</p>
                        </div>

                    </div>

                    <div class="form-row">

                        <div class="form-group col-md-5">
                            <label class="form-label">Hersteller<span class="text-danger">*</span>:</label>
                            <input type="text" name="brand" v-model="formdata.brand" class="form-control">
                            <p class="small text-muted m-0">z.B. Ford</p>
                            <div class="invalid-feedback d-block" v-if="formdata_errors.includes('brand')">
                                Bitte geben Sie Ihren Hersteller an.
                            </div>
                        </div>

                        <div class="form-group col-md-5">
                            <label class="form-label">Modell<span class="text-danger">*</span>:</label>
                            <input type="text" name="model" v-model="formdata.model" class="form-control">
                            <p class="small text-muted m-0">z.B. Focus</p>
                            <div class="invalid-feedback d-block" v-if="formdata_errors.includes('model')">
                                Bitte geben Sie Ihr Modell an.
                            </div>
                        </div>

                    </div>-->

					<div class="form-group mt-2">
					    <label class="form-label">Bemerkung:</label>
					    <textarea name="description" v-model="formdata.comment" class="form-control"></textarea>
					    <p class="small text-muted">Platz für zusätzliche Infos.</p>
					</div>

					<div v-if="content.service_info_before_booking" class="mb-2" v-html="content.service_info_before_booking"></div>

					<button class="btn btn-primary my-3" @click="onBookNow()" :disabled="loadingBookNow">
						<div class="spinner-border text-primary mr-2" role="status" v-if="loadingBookNow">
            				<span class="sr-only">Loading...</span>
        				</div>
            			Jetzt buchen</button>
		  			<hr />

		  		</div>

		  	</div>
			<!--<div v-if="formdata.selectedAppointmentSlot">

				<h5>Appointment Slots</h5>
				<div v-for="appintmentSlot in formdata.selectedAppointmentSlot.appointmentSlots">
					<div class="card p-1 mb-1">
						<div v-if="appintmentSlot.type == 0"><strong>Undefined</strong></div>
						<div v-if="appintmentSlot.type == 1"><strong>ViewingAppointment</strong></div>
						<div v-if="appintmentSlot.type == 2"><strong>VehicleArrival</strong></div>
						<div v-if="appintmentSlot.type == 3"><strong>VehicleDelivery</strong></div>
						<div v-if="appintmentSlot.type == 4"><strong>DirectAcceptance</strong></div>
						<div v-if="appintmentSlot.type == 5"><strong>PickupServiceDriver</strong></div>
						<div v-if="appintmentSlot.type == 6"><strong>DeliveryServiceDriver</strong></div>
						<div><strong>{{ formatDateTime(appintmentSlot.start) }} Uhr</strong></div>
						<small>{{ appintmentSlot }}</small>
					</div>
				</div>

				<h5>Service Slots</h5>
				<div v-for="serviceSlot in formdata.selectedAppointmentSlot.serviceSlots">
					<div class="card p-1 mb-1">
						<div><strong>{{ serviceSlot.description }}</strong></div>
						<div><strong>{{ formatDateTime(serviceSlot.start) }} Uhr</strong></div>
						<small>{{ serviceSlot }}</small>
					</div>
				</div>

			</div>-->


  		</div>

  		<div v-if="jobInfo">
  			<h5 v-if="content.service_info_after_booking" class="mb-4" v-html="content.service_info_after_booking"></h5>
			<div class="row mb-4">
			    <div class="col-sm-4">{{ jobInfo.value.progressInfo.textLeft }}</div>
			    <div class="col-sm-4"><img :src="jobInfo.value.progressInfo.imageUri" class="img-fluid"></div>
			    <div class="col-sm-4">{{ jobInfo.value.progressInfo.textRight }}</div>
			</div>
  		</div>


		<!--<div class="debug mt-4">
			<p>Ausgewählter Servicebereich (Area): <span>{{ formdata.selectedArea }}</span></p>
	  		<p>Ausgewählte Servicegruppe (Group): <span>{{ formdata.selectedGroup }}</span></p>
	  		<p>Ausgewählte Serviceleistungen: <span>{{ formdata.selectedServices }}</span></p>
	  		<p>Aus Auswahl Serviceleistungen ergeben sich requiredOptions: <span>{{ requiredOptions }}</span></p>
	  		<p>possibleOptions: <span>{{ possibleOptions }}</span></p>
	  		<p>Ausgewählte Serviceoptionen {{ formdata.selectedAdditionalOptions.length }}: <span>{{ formdata.selectedAdditionalOptions }}</span></p>
	  		<p>Übergabezeitpunkt: <span>{{ formdata.optionInKey }}</span></p>
	  		<p>Rückgabezeitpunkt: <span>{{ formdata.optionOutKey }}</span></p>
	  	</div>-->

  	</div>

  </div>
</template>

<script>
import KSRSelectVehicle from "./KSRSelectVehicle";
export default {
    name: "KSRMechanik",
    components: { KSRSelectVehicle },
    data() {
        return {
        	areas: [],
        	services: {},
        	servicesSet: false,
        	requiredOptions: [],
        	possibleOptions: [],
        	possibleOptionsInitial: [],
        	servicesAdditionalOptions: {},
        	additionalOptionsSet: false,
        	servicesInOutOptions: {},
        	serviceSlots: {},
        	serviceSlotsDayIn: [],
        	serviceSlotsDayOut: [],
        	selectedAppointmentTimeIn: '',
        	selectedAppointmentTimeOut: '',
        	selectedDateTimeIn: '',
        	selectedDateTimeOut: '',
        	singleSlotOut: false,
        	loading: false,
        	loadingBookNow: false,
        	content: {},
        	jobInfo: false,
        	formdata: {
        		selectedArea: '',
        		selectedGroup: '',
        		selectedService: '',
        		selectedServices: [],
        		selectedAdditionalOptions: [],
        		optionInKey: '',
        		optionOutKey: '',
        		selectedAppointmentSlot: '',
        		comment: '',
        		currentDay: new Date(),
        		licenseplate: '',
        		ez: '',
        		brand: '',
        		model: '',
        		vin: ''
        	},
        	formdata_errors: [],
        	datepickerIn: {
        	selectedDate: '',
					attributes: {
                    min_date: new Date(),
                    max_date: '',
                    disabled_dates: {},
                    //disabled_dates: { weekdays: [1] },
                    available_dates: [],
                }
        	},
        	datepickerOut: {
        	selectedDate: '',
					attributes: {
                    min_date: new Date(),
                    max_date: '',
                    disabled_dates: {},
                    //disabled_dates: { weekdays: [1] },
                    available_dates: [],
                }
        	},
        	adjustAppointmentTimeIn: false,
        	adjustAppointmentTimeOut: false,
        	debug: false
        }
    },
    computed: {
    	calendarEndDay() {
        	let currentDayMom = moment(this.formdata.currentDay);
        	return currentDayMom.add(7, 'days');
    	}
    },
 	created() {

 		//console.log('created called.');
 		//console.log(this.storeId);

		// get content
		console.log("get content ser");
		let _this = this;
		this.loading = true;
        axios.get('/api/ksr/'+this.storeId+'/content')
 		.then((response) => {
            _this.content = response.data;
            _this.loading = false;
            //console.log(response.data);
        });

        if(this.kit) {

        	//console.log('get services');
        	//console.log('/api/ksr/'+this.storeId+'/services');
        	// get services
        	this.loading = true;
        	let _this = this;
            axios.get('/api/ksr/'+this.storeId+'/services')
            .then((response) => {
            	_this.areas = response.data.areas;
                _this.services = response.data.services;
                _this.loading = false;

                // automatically set area if there is only one area
		        if(Object.keys(_this.areas).length == 1) {
		        	_this.onSetArea(Object.keys(_this.areas)[0]);
		        }

		        // set default date ranges for datepicker
		        let datepickerInMaxDate = moment(_this.datepickerIn.attributes.min_date).add(7, 'days');
        		_this.datepickerIn.attributes.max_date = datepickerInMaxDate.format('YYYY-MM-DD');
        		let datepickerOutMaxDate = moment(_this.datepickerOut.attributes.min_date).add(7, 'days');
        		_this.datepickerOut.attributes.max_date = datepickerOutMaxDate.format('YYYY-MM-DD');

            });

        }

    },
    methods: {
    	openLoginWindow() {
    		this.$parent.openLoginWindow('service');
    	},
    	onSetArea(area) {
    		this.formdata.selectedArea = area;
    		// automatically set first group if there is only one group
    		if(this.areas[area].groups.length == 1) {
    			this.onSetGroup(this.areas[area].groups[0]);
    		}
    	},
      	onSetGroup(group) {
    		this.formdata.selectedGroup = group;
    		// automatically set first service if there is only one group
    		if(this.services.value.length == 1) {
    			this.onAddService(this.services.value[0]);
    			this.updateRequiredOptions();
    			this.onSetServices();
    		}
    	},
    	onAddService(service) {
    		this.formdata.selectedServices.push(service);
    		this.updateRequiredOptions();
    	},
    	onRemoveService(service) {
			this.formdata.selectedServices = this.formdata.selectedServices.filter(function(value, index, arr){
		        return service !== value;
		    });
		    this.updateRequiredOptions();
    	},
    	onToggleService(service) {
    		if(!this.formdata.selectedServices.includes(service)) {
    			this.onAddService(service);
    		}
    		else {
    			this.onRemoveService(service);
    		}
    	},
    	updateRequiredOptions() {
		    this.requiredOptions = [];
    		let _this = this;
    		this.formdata.selectedServices.forEach(function(service) {
	    		service.requiredOptions.forEach(function(item) {
	    			_this.requiredOptions.push(item);
	    		});
	    	});
    	},
      onSetServices() {
      		let _this = this;
      		this.loading = true;
            axios.get('/api/ksr/'+this.storeId+'/services-additional-options')
            .then((response) => {
            	_this.servicesSet = true;
                _this.servicesAdditionalOptions = response.data;
                _this.findPossibleOptions();
                if(_this.possibleOptions.length == 0) { // jump to next page if no options are available
                	_this.onSetAdditionalOptions();
                }
                _this.loading = false;
								setTimeout(function() {
                    var element = document.querySelector(".step-4");
                    element.scrollIntoView();
                }, 200);
            });
    	},
    	findPossibleOptions() {
			//let possibleOtherOptions = [];
			let possibleOtherOptions;
			let _this = this;
			if(this.requiredOptions.length > 0) {
				_this.requiredOptions.forEach(function(requiredOptionId) { // z.B. 1
					_this.servicesAdditionalOptions.value.forEach(function(option) {
						if(requiredOptionId == option.option) {
							//possibleOtherOptions = option.possibleOtherOptions; // WAR
							option.possibleOtherOptions.forEach(function(possibleOtherOptionId) {
								_this.possibleOptions.push(possibleOtherOptionId);
							});
						}
					});
				});
				//_this.possibleOptions = possibleOtherOptions;  // WAR
			}
			else {
				// UPDATE 23-03-03_ if no requiredOptions are set => make all options possible
				_this.servicesAdditionalOptions.value.forEach(function(option) {
					_this.possibleOptions.push(option.option);
				});
			}
			_this.possibleOptionsInitial = _this.possibleOptions;
    	},
    	onAddAdditionalOption(option) {
    		this.formdata.selectedAdditionalOptions.push(option);
    		// possibleOptions
			//if(this.formdata.selectedAdditionalOptions.length > 0 && this.possibleOptions.length == 0) {
				this.possibleOptions = this.formdata.selectedAdditionalOptions[0].possibleOtherOptions;
			//}

    	},
    	onRemoveAdditionalOption(option) {
			this.formdata.selectedAdditionalOptions = this.formdata.selectedAdditionalOptions.filter(function(value, index, arr){
		        return value.option !== option.option;
		    });
		    if(this.formdata.selectedAdditionalOptions.length == 0) {
		    	this.possibleOptions = [];
		    	this.findPossibleOptions();
		    }
    	},
    	onToggleAdditionalOption(option) {
    		if(!this.formdata.selectedAdditionalOptions.includes(option)) {
    			this.onAddAdditionalOption(option);
    		}
    		else {
    			this.onRemoveAdditionalOption(option);
    		}
    	},
    	onSetAdditionalOptions() {
    		let _this = this;
    		this.additionalOptionsSet = true;
    		this.loading = true;
            axios.get('/api/ksr/'+this.storeId+'/services-in-out-options')
            .then((response) => {
                this.servicesInOutOptions = response.data;
                _this.loading = false;
								setTimeout(function() {
                    var element = document.querySelector(".step-5");
                    element.scrollIntoView();
                }, 200);
            });
    	},
    	onSetOptionIn(key) {
    		//console.log(key);
    		// OUT 16.07.2023 Abholzeitraum wird automatisch gesetzt
    		/*if(!this.hasReturnDate()) {
    			this.formdata.optionInKey = key;
    			this.formdata.optionOutKey = key;
    			this.getServiceSlots();
    		}
    		else {
    			this.formdata.optionInKey = key;
    		}*/
    		// IN 16.07.2023: Abholzeitraum wird automatisch gesetzt
  			this.formdata.optionInKey = key;
  			this.formdata.optionOutKey = key;
  			this.getServiceSlots();
    	},
    	onSetOptionOut(key) {
    		this.formdata.optionOutKey = key;
    		this.getServiceSlots();
    	},
    	getServiceSlots() {
    		let _this = this;
    		this.loading = true;
    		this.datepickerIn.attributes.available_dates = [];
    		this.datepickerOut.attributes.available_dates = [];
    		axios.post('/api/ksr/'+this.storeId+'/search-service-slots', this.formdata)
            .then((response) => {
                this.serviceSlots = response.data;
                let _this = this;
                this.serviceSlots.value.forEach(function(slot) {
                	/* [ 0 = Undefined, 1 = ViewingAppointment, 2 = VehicleArrival, 3 = VehicleDelivery, 4 = DirectAcceptance, 5 = PickupServiceDriver, 6 = DeliveryServiceDriver ] */
                	slot.appointmentSlots.forEach(function(appointmentSlot) {
                		//if(appointmentSlot.type == 4 || appointmentSlot.type == 5) {
                		if(appointmentSlot.type == 1 || appointmentSlot.type == 2 || appointmentSlot.type == 4 || appointmentSlot.type == 5) {
                			// calculate setting_planning_buffer
                			let minDateWithBuffer = moment();
                			//if(_this.content.setting_planning_buffer) {
                				//minDateWithBuffer.add(_this.content.setting_planning_buffer, 'hours');
                			//}
                			//console.log('min_date_with_buffer: ' + minDateWithBuffer.format('YYYY-MM-DD HH:mm'));
                			//console.log('current slot start: ' + moment(appointmentSlot.start).format('YYYY-MM-DD HH:mm'));
                			if(moment(appointmentSlot.start) > minDateWithBuffer) {
                				//console.log(appointmentSlot.start);
                				_this.datepickerIn.attributes.available_dates.push(appointmentSlot.start);
                			}
                		}
                	});

                });

                // set min_date for datepicker
                _this.datepickerIn.attributes.min_date = _this.datepickerIn.attributes.available_dates[0];
                _this.datepickerOut.attributes.min_date = _this.datepickerIn.attributes.available_dates[0];
                //console.log(_this.datepickerIn.attributes.available_dates);
                _this.loading = false;
                setTimeout(function() {
                    var element = document.querySelector(".step-7");
                    element.scrollIntoView();
                }, 200);


                if (_this.datepickerIn.attributes.available_dates[0] !== undefined) {

                    // Sort the dates
                    let availableDates = _this.datepickerIn.attributes.available_dates;
                    //console.log(availableDates);
                    //availableDates.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
                    //console.log(availableDates);

                    // Pick the first date
                    let firstAvailableDate = availableDates[0];
                    //console.log(firstAvailableDate);

                    // set first day available in calendar
                    _this.datepickerIn.selectedDate = new Date(firstAvailableDate);
                    var dayObj = new Object();
                    dayObj.date = firstAvailableDate;
                    // suchzeitraum anpassen
                    _this.onDayClickedIn(dayObj);

                    // Get the first day of the week from dayObj and set formdata.currentDay
                    let selectedMoment = moment(dayObj.date);
                    let firstDayOfWeek = selectedMoment.startOf('isoWeek').toDate();
                    this.formdata.currentDay = firstDayOfWeek;
                }

                // set first day available in calendar
                //_this.datepickerIn.selectedDate = new Date(_this.datepickerIn.attributes.available_dates[0]);
                //var dayObj = new Object();
                //dayObj.date = _this.datepickerIn.attributes.available_dates[0];
                //_this.onDayClickedIn(dayObj);

            });
    	},
    	hasReturnDate() {
    		if(this.requiredOptions.includes(1)) { // Warten
    			return false;
    		}
     		this.formdata.selectedAdditionalOptions.forEach(function(option) {
    			if(option.option == 1) { // Warten
    				return false;
    			}
    		});
    		return true;
    	},
    	formatTime(dateString) {
    		let dateObj = new Date(dateString);
    		let momentObj = moment(dateObj);
    		momentObj.set('minute', 0);
    		return momentObj.add(1, 'hours').format('HH:mm');
    	},
    	formatDate(dateString) {
    		let dateObj = new Date(dateString);
    		let momentObj = moment(dateObj);
    		return momentObj.format('D.M');
    	},
    	formatDateWithDay(dateString) {
    		let dateObj = new Date(dateString);
    		let momentObj = moment(dateObj);
    		return this.formatLocaleDay(momentObj.format('dddd')) + ', <span class="highlighted">' + momentObj.format('D') + '.</span>' + momentObj.format('M.YYYY');
    	},
    	formatDateYear(dateString) {
    		let dateObj = new Date(dateString);
    		let momentObj = moment(dateObj);
    		return momentObj.format('D.M.YYYY');
    	},
    	formatDateTime(dateString) {
    		let dateObj = new Date(dateString);
    		let momentObj = moment(dateObj);
    		return momentObj.format('D.M HH:mm');
    	},
    	/*slotOnSelectedDay(slot, selectedDate) {
    		let selectedDateMom = moment(selectedDate);
    		let match = false;
    		console.log('selectedDateMom: ' + selectedDateMom.format('D.M HH:mm'));
        	slot.appointmentSlots.forEach(function(appointmentSlot) {
        		if(appointmentSlot.type == 4 || appointmentSlot.type == 5) {
        			let appointmentSlotStartMom = moment(appointmentSlot.start);
        			console.log('appointmentSlotStartMom: ' + appointmentSlotStartMom.format('D.M HH:mm'));
        			if(appointmentSlotStartMom.format('YYYY-MM-DD') == selectedDateMom.format('YYYY-MM-DD')) {
        				console.log("match");
        				match = true;
        			}
        		}
        	});
        	return match;
    	},*/
    	onDayClickedIn(day) {
    		//console.log(day);
    		// filter after click on day
    		let _this = this;
    		let selectedDateMom = moment(day.date);
    		//console.log(selectedDateMom);
    		//console.log(selectedDateMom.format('YYYY-MM-DD'));
    		//console.log(this.datepickerIn.attributes.available_dates);

    		// ============================
    		let dates = this.datepickerIn.attributes.available_dates;
    		let selectedDateMomStr = selectedDateMom.format('YYYY-MM-DD'); // e.g. 2024-12-11
				const exists = dates.some(dateString => {
				    const dateOnly = dateString.split('T')[0]; // Extract only the date part
				    return dateOnly === selectedDateMomStr; // Compare with selectedDateMom
				});
				//console.log(exists);
				if(!exists) {
					const userConfirmed = confirm("Der Tag liegt außerhalb des aktuellen Suchzeitraums. Es wird ein neuer Suchzeitraum geladen. Fortfahren?");
					// Check the user's response
					if (userConfirmed) {
					    // Proceed with the action
						  let currentDayMom = selectedDateMom;
		        	let nextDayMom = currentDayMom.set({"hour": 0, "minute": 0});
		        	this.formdata.currentDay = nextDayMom;
		        	//console.log(nextDayMom.format('YYYY-MM-DD'));
		        	this.datepickerIn.attributes.min_date = nextDayMom.format('YYYY-MM-DD');
		        	this.datepickerOut.attributes.min_date = nextDayMom.format('YYYY-MM-DD');
		        	let nextDayMomEnd = nextDayMom.clone().add(7, 'days');
		        	this.datepickerIn.attributes.max_date = nextDayMomEnd.format('YYYY-MM-DD');
		        	this.datepickerOut.attributes.max_date = nextDayMomEnd.format('YYYY-MM-DD');
		        	this.getServiceSlots();
		        	return true;
					} else {
					    // Abort the action
					}
				}

				// ============================


    		this.selectedAppointmentTimeIn = '';
    		this.selectedAppointmentTimeOut = '';
    		this.singleSlotOut = false;
		  	this.serviceSlotsDayIn = new Set(); // new set
            console.log(_this.serviceSlotsDayIn);
            this.serviceSlots.value.forEach(function(slot) {
            	slot.appointmentSlots.forEach(function(appointmentSlot) {
            		// [ 0 = Undefined, 1 = ViewingAppointment, 2 = VehicleArrival, 3 = VehicleDelivery, 4 = DirectAcceptance, 5 = PickupServiceDriver, 6 = DeliveryServiceDriver ]
            		//if(appointmentSlot.type == 4 || appointmentSlot.type == 5) {
            		if(appointmentSlot.type == 1 || appointmentSlot.type == 2 || appointmentSlot.type == 4 || appointmentSlot.type == 5) {
            			let appointmentSlotStartMom = moment(appointmentSlot.start);
                        //console.log(appointmentSlotStartMom);
            			if(appointmentSlotStartMom.format('YYYY-MM-DD') == selectedDateMom.format('YYYY-MM-DD')) {
                			// calculate setting_planning_buffer
                			let minDateWithBuffer = moment();
                			//if(_this.content.setting_planning_buffer) {
                				//minDateWithBuffer.add(_this.content.setting_planning_buffer, 'hours');
                			//}
                			if(appointmentSlotStartMom > minDateWithBuffer) {
            					_this.serviceSlotsDayIn.add(appointmentSlotStartMom.format('HH:mm'));
            				}
            			}
            		}
            	});
            });
            this.serviceSlotsDayIn = Array.from(this.serviceSlotsDayIn).sort();
            //console.log(this.serviceSlotsDayIn);
    	},
     	onDayClickedOut(day) {
    		// filter after click on day
    		let _this = this;
    		let selectedDateMom = moment(day.date);
    		this.selectedAppointmentTimeOut = '';
		  	this.serviceSlotsDayOut = new Set(); // new set
            this.serviceSlots.value.forEach(function(slot) {
            	slot.appointmentSlots.forEach(function(appointmentSlot) {
	    			let match = false;
	            	slot.appointmentSlots.forEach(function(appointmentSlot) {
	            		// [ 0 = Undefined, 1 = ViewingAppointment, 2 = VehicleArrival, 3 = VehicleDelivery, 4 = DirectAcceptance, 5 = PickupServiceDriver, 6 = DeliveryServiceDriver ]
	            		//if(appointmentSlot.type == 4 || appointmentSlot.type == 5) {
	            		if(appointmentSlot.type == 1 || appointmentSlot.type == 2 || appointmentSlot.type == 4 || appointmentSlot.type == 5) {
	            			if(appointmentSlot.start == _this.selectedDateTimeIn ) {
	            				match = true;
	            			}
	            		}
	            	});
	            	if(match) {
	            		// [ 0 = Undefined, 1 = ViewingAppointment, 2 = VehicleArrival, 3 = VehicleDelivery, 4 = DirectAcceptance, 5 = PickupServiceDriver, 6 = DeliveryServiceDriver ]
	            		if(appointmentSlot.type == 3 || appointmentSlot.type == 6) {
	            			let appointmentSlotStartMom = moment(appointmentSlot.start);
	            			if(appointmentSlotStartMom.format('YYYY-MM-DD') == selectedDateMom.format('YYYY-MM-DD')) {
		            			// calculate setting_planning_buffer
	                			let minDateWithBuffer = moment();
	                			//if(_this.content.setting_planning_buffer) {
	                				//minDateWithBuffer.add(_this.content.setting_planning_buffer, 'hours');
	                			//}
	                			if(appointmentSlotStartMom > minDateWithBuffer) {
	            					_this.serviceSlotsDayOut.add(appointmentSlotStartMom.format('HH:mm'));
	            				}
	            			}
	            		}
	            	}
            	});
            });
            //console.log(this.serviceSlotsDayOut);
            this.serviceSlotsDayOut = Array.from(this.serviceSlotsDayOut).sort();
    	},
    	onSetAppointmentSlotIn(timeStr) {
    		//click on timeIn
    		let _this = this;

    		// reset
    		this.selectedAppointmentTimeOut = '';
    		this.singleSlotOut = false;
    		this.datepickerOut.attributes.available_dates = [];

    		let selectedDateMom = moment(this.datepickerIn.selectedDate);
    		let selectedDateTimeMom = moment( selectedDateMom.format('YYYY-MM-DD') + ' ' + timeStr );
    		this.selectedAppointmentTimeIn = timeStr;
    		this.datepickerOut.attributes.available_dates = []; // empty array
    		this.singleSlotOut = false;
    		this.selectedDateTimeIn = selectedDateTimeMom.toISOString().split('.')[0]+"Z";
    		//console.log(selectedDateTimeMom.toISOString().split('.')[0]+"Z");

    		this.serviceSlots.value.forEach(function(slot) {
    			let match = false;
            	slot.appointmentSlots.forEach(function(appointmentSlot) {
            		// [ 0 = Undefined, 1 = ViewingAppointment, 2 = VehicleArrival, 3 = VehicleDelivery, 4 = DirectAcceptance, 5 = PickupServiceDriver, 6 = DeliveryServiceDriver ]
            		//if(appointmentSlot.type == 4 || appointmentSlot.type == 5) {
            		if(appointmentSlot.type == 1 || appointmentSlot.type == 2 || appointmentSlot.type == 4 || appointmentSlot.type == 5) {
            			let appointmentSlotStartMom = moment(appointmentSlot.start);
            			if(appointmentSlotStartMom.format('YYYY-MM-DD HH:mm') == selectedDateTimeMom.format('YYYY-MM-DD HH:mm') ) {
            				match = true;
            			}
            		}
            	});
            	if(match) {
	            	slot.appointmentSlots.forEach(function(appointmentSlot) {
	            		if(appointmentSlot.type == 3 || appointmentSlot.type == 6) {
	            			_this.datepickerOut.attributes.available_dates.push(appointmentSlot.start);
	            		}
	            	});
            	}
            });

    		// set min_date for datepicker_out
    		let momentStr = moment(this.datepickerOut.attributes.available_dates[0]);
    		this.datepickerOut.attributes.min_date = momentStr.format('YYYY-MM-DD');
    		this.datepickerOut.selectedDate = '';


            // check for single match (e.g. Räderwechsel) and preselect
            if(this.datepickerOut.attributes.available_dates.length == 1) {
            	const day = { date: this.datepickerOut.attributes.available_dates[0] };
            	this.datepickerOut.selectedDate = new Date(this.datepickerOut.attributes.available_dates[0]);
            	this.onDayClickedOut(day);
            	let momentStr = moment(this.datepickerOut.attributes.available_dates[0]);
            	//console.log(momentStr.format('HH:mm'));
            	this.onSetAppointmentSlotOut(momentStr.format('HH:mm'));
            	this.singleSlotOut = true;
            }

            // hide calendar
            this.adjustAppointmentTimeIn = false;

    	},
        onSetAppointmentSlotOut(timeStr) {
    		//click on timeOut
    		let _this = this;
    		let selectedDateMom = moment(this.datepickerOut.selectedDate);
    		let selectedDateTimeMom = moment( selectedDateMom.format('YYYY-MM-DD') + ' ' + timeStr );
    		this.selectedAppointmentTimeOut = timeStr;
    		this.selectedDateTimeOut = selectedDateTimeMom.toISOString().split('.')[0]+"Z";

    		this.serviceSlots.value.forEach(function(slot) {
    			let match = false;
            	slot.appointmentSlots.forEach(function(appointmentSlot) {
            		// [ 0 = Undefined, 1 = ViewingAppointment, 2 = VehicleArrival, 3 = VehicleDelivery, 4 = DirectAcceptance, 5 = PickupServiceDriver, 6 = DeliveryServiceDriver ]
            		//if(appointmentSlot.type == 4 || appointmentSlot.type == 5) {
            		if(appointmentSlot.type == 1 || appointmentSlot.type == 2 || appointmentSlot.type == 4 || appointmentSlot.type == 5) {
            			if(appointmentSlot.start == _this.selectedDateTimeIn ) {
            				match = true;
            			}
            		}
            	});
            	if(match) {
	            	slot.appointmentSlots.forEach(function(appointmentSlot) {
	            		if(appointmentSlot.type == 3 || appointmentSlot.type == 6) {
	            			if(appointmentSlot.start == _this.selectedDateTimeOut ) {
	            				_this.formdata.selectedAppointmentSlot = slot;
	            			}
	            		}
	            	});
            	}
            });

            // hide calendar
            this.adjustAppointmentTimeIn = false;
            this.adjustAppointmentTimeOut = false;

            setTimeout(function() {
                var element = document.querySelector("#wrapper-select-vehicle");
                element.scrollIntoView();
            }, 200);

        },
        onAddWeek() {
        	let currentDayMom = moment(this.formdata.currentDay);
          console.log(currentDayMom);
        	let nextDayMom = currentDayMom.add(7, 'days').set({"hour": 0, "minute": 0});
        	this.formdata.currentDay = nextDayMom;
        	//console.log(nextDayMom.format('YYYY-MM-DD'));
        	this.datepickerIn.attributes.min_date = nextDayMom.format('YYYY-MM-DD');
        	this.datepickerOut.attributes.min_date = nextDayMom.format('YYYY-MM-DD');
        	let nextDayMomEnd = nextDayMom.clone().add(7, 'days');
        	this.datepickerIn.attributes.max_date = nextDayMomEnd.format('YYYY-MM-DD');
        	this.datepickerOut.attributes.max_date = nextDayMomEnd.format('YYYY-MM-DD');
        	this.getServiceSlots();
        },
        onRemoveWeek() {
        	let currentDayMom = moment(this.formdata.currentDay);
          console.log(currentDayMom);
        	let prevDayMom = currentDayMom.subtract(7, 'days');
        	this.formdata.currentDay = prevDayMom;
        	//console.log(prevDayMom.format('YYYY-MM-DD'));
        	this.datepickerIn.attributes.min_date = prevDayMom.format('YYYY-MM-DD');
        	this.datepickerOut.attributes.min_date = prevDayMom.format('YYYY-MM-DD');
        	let prevDayMomEnd = prevDayMom.clone().add(7, 'days');
        	this.datepickerIn.attributes.max_date = prevDayMomEnd.format('YYYY-MM-DD');
        	this.datepickerOut.attributes.max_date = prevDayMomEnd.format('YYYY-MM-DD');
        	this.getServiceSlots();
        },
        hasNotPast() {
        	let currentDayMom = moment(this.formdata.currentDay);
        	let prevDayMom = currentDayMom.subtract(6, 'days').set({"hour": 0, "minute": 0});
        	let today = moment().set({"hour": 0, "minute": 0});
        	return prevDayMom >= today;
        },
        onBookNow() {
        	// Validation
            this.formdata_errors = [];
            if(this.formdata.licenseplate == '') {
                this.formdata_errors.push('licenseplate');
            }
            if(this.formdata.brand == '') {
                this.formdata_errors.push('brand');
            }
            if(this.formdata.model == '') {
                this.formdata_errors.push('model');
            }

            // scroll to top
            if(this.formdata_errors.length) {
                //var element = document.querySelector("#booking-container");
                //element.scrollIntoView();
                setTimeout(function() {
                    var element = document.querySelector(".invalid-feedback");
                    element.scrollIntoView();
                }, 200);
            }

            if(this.formdata_errors.length == 0) {
	        	let _this = this;
	        	this.loadingBookNow = true;
				axios.post('/api/ksr/'+this.storeId+'/book-service-slot/?identityToken='+this.kit, this.formdata)
	            .then((response) => {
	            	//console.log(response);
	            	if(response.data) {
	            		_this.jobInfo = response.data;
	            		_this.loadingBookNow = false;
									setTimeout(function() {
                    var element = document.querySelector(".ksr-booking--body");
                    element.scrollIntoView();
                }, 200);
	            	}
	            });
            }
        },
        formatLicensePlate(licenseplate) {
            if(!licenseplate.includes('-'))
                licenseplate = licenseplate.replace(/ /g,'-');
            licenseplate = licenseplate.toUpperCase();
            this.formdata.licenseplate = licenseplate;
        },
		formatLocaleDay(str) {
			if(str == 'Monday') { return 'Montag'; }
			if(str == 'Tuesday') { return 'Dienstag'; }
			if(str == 'Wednesday') { return 'Mittwoch'; }
			if(str == 'Thursday') { return 'Donnerstag'; }
			if(str == 'Friday') { return 'Freitag'; }
			if(str == 'Saturday') { return 'Samstag'; }
			if(str == 'Sunday') { return 'Sonntag'; }
		},
	    setVehicle(vehicle) {
            //console.log('vehicle selected');
            //console.log(vehicle);
            this.formdata.brand = vehicle.brand;
            this.formdata.model = vehicle.model;
            if(vehicle.registration_date) {
            	this.formdata.ez = moment(vehicle.registration_date).format('YYYY-MM-DD');
            }
            if(vehicle.vin) {
            	this.formdata.vin = vehicle.vin;
            }
            this.formdata.licenseplate = vehicle.licenseplate;
        }
    },
    props: ['kit', 'storeId']
};
</script>

<style>
	.debug {
		border:1px solid #ccc;
		padding:5px;
		font-family:monospace;
		font-size:12px;
		font-weight:bold;
	}
	.debug p {
		margin-bottom:5px;
	}
	.debug p span {
		font-weight:normal;
	}
	.appointment-slot {
		cursor:pointer;
	}
	.appointment-slot:hover {
		border-color:#555;
	}
	.vc-svg-icon[data-v-63f7b5ec] {
	    color: #c1c1c1;
	}
	/*.step-7 .vc-arrows-container {
		display:none !important;
	}*/
</style>
